export const themeTokens = Object.freeze({
  "--primary-color": "#3aa8e8",
  "--secondary-color": "#4f5ff2",
  "--tertiary-color": "#26cfef",
  "--background-color": "#0b1120",
  "--surface-color": "#152138",
  "--surface-elevated-color": "#24344f",
  "--text-color": "#e6edf5",
  "--muted-text-color": "#dce3fb",
  "--font-family": '"Inter Variable", "Inter", "Inter var", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  "--heading-font-family": '"Inter Variable", "Inter", "Inter var", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  "--border-radius": "8px",
  "--button-text-color": "#ffffff",
  "--button-padding-y": "0.625rem",
  "--button-padding-x": "1.35rem",
  "--table-header-bg": "#23324a",
  "--table-header-text": "#f1f5ff",
  "--table-row-hover": "rgba(160, 178, 208, 0.14)",
  "--table-border-color": "#253249",
  "--nav-background": "rgba(12, 19, 36, 0.9)",
  "--focus-ring": "rgba(58, 168, 232, 0.65)",
})

export function applyTheme(tokens = themeTokens) {
  if (typeof document === "undefined") return tokens
  const root = document.documentElement
  for (const [cssVar, value] of Object.entries(tokens)) {
    root.style.setProperty(cssVar, value)
  }
  return tokens
}

export default themeTokens
